export default __webpack_public_path__ + "static/media/Chennai1.37fed570.jpg";